import { useField } from 'formik'
import { SelectProps } from 'components/Select/Types'
import { Chip } from 'components/Chip/Chip'
import Styles from './StringInput.module.scss'
import cx from 'classnames'

interface Props extends Omit<SelectProps<string>, 'name' | 'children'> {
  name: string
  isCarousel?: boolean
  size?: 'sm' | 'md' | 'lg'
  children: JSX.Element[]
  chipVariant?: 'catalogue' | 'flat' | 'wizard' | 'wizardsV3' | 'filter' | 'button'
}

export const SelectPillsInput = (props: Props) => {
  const [field, , helpers] = useField(props.name)
  const chipVariant = props.chipVariant || 'catalogue'

  return (
    <div className={cx(Styles.chipsInput, { [Styles.isCarousel]: props.isCarousel })}>
      {props.children.map((option) => (
        <Chip
          deletable={false}
          variant={chipVariant}
          key={option.key}
          onPress={() => helpers.setValue(option.key)}
          isSelected={field.value === option.key}
          size={props.size}
        >
          {option.key}
        </Chip>
      ))}
    </div>
  )
}
